module.exports = __webpack_public_path__ + "img/home4E.c169d008.png";